import React, { useState, useEffect } from 'react';
import { Switch, Space, Typography } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';

const { Text } = Typography;

/**
 * Language toggle component specifically for Care Planning imaging forms
 * Provides a simple toggle between English and Vietnamese for parameter labels
 * Persists language preference in sessionStorage for the current session
 */
const ImagingLanguageToggle = ({ onLanguageChange, style = {} }) => {
  const [isVietnamese, setIsVietnamese] = useState(false);

  // Load language preference from sessionStorage on component mount
  useEffect(() => {
    const savedLanguage = sessionStorage.getItem('carePlanningImagingLanguage');
    if (savedLanguage === 'vi') {
      setIsVietnamese(true);
      onLanguageChange && onLanguageChange('vi');
    } else {
      setIsVietnamese(false);
      onLanguageChange && onLanguageChange('en');
    }
  }, [onLanguageChange]);

  // Handle language toggle
  const handleToggle = (checked) => {
    const newLanguage = checked ? 'vi' : 'en';
    setIsVietnamese(checked);
    
    // Save preference to sessionStorage
    sessionStorage.setItem('carePlanningImagingLanguage', newLanguage);
    
    // Notify parent component of language change
    onLanguageChange && onLanguageChange(newLanguage);
  };

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'flex-end',
      marginBottom: 16,
      padding: '8px 12px',
      backgroundColor: '#f5f5f5',
      borderRadius: '6px',
      border: '1px solid #d9d9d9',
      ...style 
    }}>
      <Space align="center">
        <GlobalOutlined style={{ color: '#1890ff', fontSize: '16px' }} />
        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
          Language:
        </Text>
        <Text 
          style={{ 
            fontSize: '13px', 
            color: !isVietnamese ? '#1890ff' : '#8c8c8c',
            fontWeight: !isVietnamese ? 600 : 400
          }}
        >
          EN
        </Text>
        <Switch
          checked={isVietnamese}
          onChange={handleToggle}
          size="small"
          style={{
            backgroundColor: isVietnamese ? '#1890ff' : '#d9d9d9'
          }}
        />
        <Text 
          style={{ 
            fontSize: '13px', 
            color: isVietnamese ? '#1890ff' : '#8c8c8c',
            fontWeight: isVietnamese ? 600 : 400
          }}
        >
          VI
        </Text>
      </Space>
    </div>
  );
};

export default ImagingLanguageToggle;
